import { CapoPlugin } from "E:/W2/MedCAT_2026/MedCAT.Cms/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];